import { runIfFn } from '@mote/helpers'
import { Dialog } from '@mote/ui'

export const Popup = ({
  buttons,
  title,
  content,
  onClose,
  width = 320,
  isOpen = true,
  titleProps = {},
  contentProps = {},
  buttonsProps = {},
  ...rest
}) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} maxWidth={width} {...rest}>
      {dialogProps => (
        <>
          {title && (
            <Dialog.Header {...titleProps}>
              {runIfFn(title, dialogProps)}
            </Dialog.Header>
          )}
          <Dialog.Content {...contentProps}>
            {runIfFn(content, dialogProps)}
          </Dialog.Content>
          {buttons && (
            <Dialog.Footer {...buttonsProps}>
              {runIfFn(buttons, dialogProps)}
            </Dialog.Footer>
          )}
        </>
      )}
    </Dialog>
  )
}
